import { createStandaloneToast } from '@chakra-ui/react';

export const { ToastContainer, toast: toastInstance } = createStandaloneToast();
